import { render, staticRenderFns } from "./SolicitudReclamaciones.vue?vue&type=template&id=48e54999&scoped=true"
import script from "./SolicitudReclamaciones.vue?vue&type=script&lang=ts"
export * from "./SolicitudReclamaciones.vue?vue&type=script&lang=ts"
import style0 from "./SolicitudReclamaciones.vue?vue&type=style&index=0&id=48e54999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e54999",
  null
  
)

export default component.exports